import { ReactElement, useState } from 'react';

import { Drawer } from 'antd';
import { LanguageSelector } from 'features/changeLanguage';

import { getDefaultRedirectPath } from 'entities/session';
import { ReactComponent as BurgerIcon } from 'shared/assets/icons/menu-burger.svg';
import { useMediaQuery } from 'shared/lib/react';
import { TriggerButtonColorMode } from 'shared/ui/CustomDropdown';
import { Logo } from 'shared/ui/Logo';

import MainNav from './ui/MainNav/MainNav';
import UserMenu from './ui/UserMenu/UserMenu';

import styles from './Header.module.scss';

function Header(): ReactElement {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <header className={styles.header} data-testid="header">
      <div className={styles.logoHolder}>
        <Logo href={getDefaultRedirectPath()} />
      </div>
      <div className={styles.navHolder}>{isDesktop && <MainNav />}</div>
      <div className={styles.rightSectionHolder}>
        <div className={styles.languageSelectorHolder}>
          <LanguageSelector triggerButtonColorMode={TriggerButtonColorMode.Light} />
        </div>
        <div className={styles.userMenuHolder}>
          <UserMenu />
        </div>
      </div>
      <button
        type="button"
        className={styles.burgerButton}
        data-active={isMobileNavOpen}
        onClick={() => setIsMobileNavOpen((prev) => !prev)}
      >
        <BurgerIcon />
      </button>
      {!isDesktop && (
        <Drawer open={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)}>
          <MainNav inDrawer />
        </Drawer>
      )}
    </header>
  );
}

export default Header;
